import './Home.css';

const steps = [
    {
        id: 1,
        title: 'High school',
        place: 'ESPAV',
        course: 'Science and Technology',
        status: 'Done',
    },
    {
        id: 2,
        title: 'Bachelor',
        place: 'ISEL',
        course: 'Computer and Informatics Engineering',
        status: 'Done',
    },
    {
        id: 3,
        title: 'Master',
        place: 'ISEL',
        course: 'Computer and Informatics Engineering',
        status: 'Maybe next',
    },
];

function Education() {
    return (
        <main className="container">
            <h1>Education</h1>
            <p>
                I always knew I wanted to stay close to engineering and computers, so the path was fairly clear:
                science in high school, then computer engineering at ISEL.
            </p>

            <ul className="education-list">
                {steps.map((step) => (
                    <li className="education-item" key={step.id}>
                        <span className="education-status">{step.status}</span>
                        <strong>{step.title}</strong> at {step.place}
                        <br />
                        {step.course}
                    </li>
                ))}
            </ul>
        </main>
    );
}

export default Education;
